import React, { useRef } from 'react';
import { AlertSelectPanelStyles, SelectContainer } from './Select.styled';
import BaselineKeyboardArrowDown24 from 'src/assets/images/BaselineKeyboardArrowDown24.svg';
import SortAscending from 'src/assets/images/SortAscending.svg';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export default function Select({
    isFromConsignmentAddProductGuide,
    filter = false,
    width = '100%',
    sortIcon = SortAscending,
    consignmentBilling = false,
    consignmentAdd = false,
    height = '40px',
    smWidth = '',
    marginLeft = '0px',
    xSmWidth = '',
    value = null,
    options = [],
    className = '',
    borderColor = '#0000003b',
    onChange = () => {},
    onInputChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    optionLabel = '',
    optionValue = '',
    placeholder = '',
    itemTemplate = null,
    style = {},
    disabled = false,
    borderRadius = '',
    valueTemplate = null,
    emptyMessage = '',
    labelColor = '',
    selectedLabelFontSize = '',
    selectedLabelfontFamily = '',
    hideClear=false,
    scrollHeight,
    onOpen = () => {},
    onClose = () => {}, // Added onClose prop for handling close event
    editable = false,	
    crossIconMargin = '',
    id = '',
    right = '',
    marginRight = '',
    mbMarginBottom = '',
    ipadMarginLeft='',
    iPadwidth= '',
    mbBorderRadius = '',
    sortMarginRight = '',
    isSortMobileView = false,
    sortIconWidth = '',
    sortIconRightMargin = '',
    sortIconScale = '',
    name = '', // Added name prop to handle specific behavior
    isFromProcedure = false, // Added isFromProcedure prop to handle specific behavior
    mbMarginRight,
    panelClassName = '',
    isFromInventoryConsignment = false,
    closeOnScroll = false,
    truncateLabel = false,
    isAlertTable = false,
    isAlertSort = false,
}) {
    const selectRef = useRef(null);

    useEffectWithErrorLogging(() => {
        if (!closeOnScroll) return undefined;

        const handleScroll = (event) => {
            if (!event?.target?.closest?.('.p-dropdown-panel')) {
                if (selectRef.current?.hideOverlay) {
                    selectRef.current.hideOverlay();
                } else {
                    selectRef.current?.hide?.();
                }
            }
        };

        document.addEventListener('scroll', handleScroll, true);
        return () => document.removeEventListener('scroll', handleScroll, true);
    }, [closeOnScroll], 'Select close on scroll');

    const handleChange = (event) => {
        const key = event?.originalEvent?.key;

        if (name) {
            onChange({ [name]: event.value });
        } else if (isFromProcedure && (key === 'ArrowDown' || key === 'ArrowUp')) {
            onChange(event.value, true);
        } else {
            onChange(event.value);
        }
    };

    const handleHide = () => {
        if (value && isFromProcedure) {
            onChange?.(value);
        }
        onClose?.();
    };

    const isValueValid = () => {
        if (!value || !options || options.length === 0) {
            return false;
        }
        if (optionValue) {
            return options.some(option => option[optionValue] === value);
        }        
        return options.some(option => option === value);
    };

    return (
        <>
            {isAlertTable && <AlertSelectPanelStyles />}
            <SelectContainer
                ref={selectRef}
                isFromConsignmentAddProductGuide={isFromConsignmentAddProductGuide}
                isFromInventoryConsignment={isFromInventoryConsignment}
                filter={filter}
                width={width}
                sortIcon={sortIcon}
                consignmentBilling={consignmentBilling}
                consignmentAdd={consignmentAdd}
                height={height}
                smWidth={smWidth}
                marginLeft={marginLeft}
                xSmWidth={xSmWidth}
                value={value}
                options={options}
                className={className}
                borderColor={borderColor}
                onChange={handleChange}
                onInputChange={(event) => onInputChange(event.value)}
                onFocus={onFocus}
                onBlur={onBlur}
                optionLabel={optionLabel}
                optionValue={optionValue}
                placeholder={placeholder}
                itemTemplate={itemTemplate}
                style={style}
                disabled={disabled}
                borderRadius={borderRadius}
                valueTemplate={valueTemplate}
                emptyMessage={emptyMessage}
                labelColor={labelColor}
                downArrowIcon={BaselineKeyboardArrowDown24}
                selectedLabelFontSize={selectedLabelFontSize}
                selectedLabelfontFamily={selectedLabelfontFamily}
                showClear={!hideClear && isValueValid() ? value : false}
                scrollHeight={scrollHeight}
                onShow={onOpen || (() => {})}
                onHide={handleHide}
                editable={editable}
                crossIconMargin={crossIconMargin}
                id={id}
                right={right}
                marginRight={marginRight}
                mbMarginBottom={mbMarginBottom}
                ipadMarginLeft={ipadMarginLeft}
                iPadwidth={iPadwidth}
                mbBorderRadius={mbBorderRadius}
                sortMarginRight={sortMarginRight}
                isSortMobileView={isSortMobileView}
                sortIconWidth={sortIconWidth}
                sortIconRightMargin={sortIconRightMargin}
                sortIconScale={sortIconScale}
                mbMarginRight={mbMarginRight}
                panelClassName={
                    isAlertSort
                        ? 'alerts-sort-panel'
                        : isAlertTable
                            ? 'alerts-action-panel'
                            : panelClassName
                }
                truncateLabel={truncateLabel}
            />
        </>
    );
}